import { isToday } from 'date-fns';
import { MILL_SEC_COEFF } from '~/ui/constants/common';
import { setNoon } from './date';

const isTodayDate = (date: string): boolean => {
  const utcDate = new Date(setNoon(date));
  const localDate = new Date(utcDate.getTime() + utcDate.getTimezoneOffset() * MILL_SEC_COEFF * -1);

  return isToday(localDate);
};

export default isTodayDate;
